export default __webpack_public_path__ + "static/media/count.91aa7f8f.jfif";